<template>
  <el-container style="width: 100%; text-align: left">
    <el-header>
      <global-header :app-type="appType"/>
    </el-header>
    <el-main :style="display_style[appType]">
<!--      <div class="account-type">-->
<!--        <h3 class="info-title"> 账号性质 </h3>-->
<!--        <el-divider />-->
<!--        <el-radio-group v-model="certifyType" size="medium">-->
<!--          <el-radio-button label="person"> 个人用户 </el-radio-button>-->
<!--          <el-radio-button label="enterprise"> 企业用户 </el-radio-button>-->
<!--        </el-radio-group>-->
<!--      </div>-->
<!--      <person v-if="certifyType === 'person'" :account-name="accountName" @onSubmit="handleSubmit"></person>-->
<!--      <enterprise v-else :account-name="accountName" @onSubmit="handleSubmit"></enterprise>-->
      <certify-page :account-name="accountName" @onSubmit="handleSubmit" />
    </el-main>
    <el-footer>
      <global-footer />
    </el-footer>
  </el-container>
</template>

<script>
import Config from "@/config"
import Person from "./certifyPerson"
import GlobalHeader from "@/components/GlobalHeader"
import GlobalFooter from "@/components/GlobalFooter"
import Enterprise from "./certifyEnterprise"
import { filetoBase64Img, notify, getAppType } from "@/utils/util"
import { certify, certifyPerson, certifyEnterprise, getCertificationInfo} from "@/api/certify"
import CertifyPage from "@/views/Certify/certifyPage.vue";
import Cookies from "js-cookie";
import {removeToken} from "@/utils/auth";
export default {
  name: "Certify",
  components: { Person, Enterprise, GlobalHeader, GlobalFooter, CertifyPage },
  data () {
    return {
      appType: "",
      display_style: {CERTIFICATION_MOBILE: "margin: 0 5%; min-width: 350px", CERTIFICATION_PC: "margin: 0 20%"},
      certifyType: "person",
      accountName: "",
      form: {
        accountName: "",
        personName: "",
        cardType: 0,
        cardId: "",
        contact: "",
      },
      rules: {
        accountName: [{required: true, message: "请输入TP-LINK ID", trigger: "blur"}],
        personName: [{required: true, message: "请输入真实姓名", trigger: "blur"}],
        cardType: [{required: true, message: "请输入证件类型", trigger: "blur"}],
        cardId: [{required: true, message: "请输入正确的证件号码", trigger: "blur"}],
        contact: [{required: true, message: "请输⼊⼿机号或电⼦邮箱", trigger: "blur"}]
      },
      imageUrl: "",
      checked: false,
      loading: false,
      Config
    }
  },
  methods: {
    logout () {
      Cookies.remove("accountName")
      Cookies.remove("accountPassword")
      Cookies.remove("rememberMe")
      removeToken()
      console.log('Back to login page!')
      this.$router.replace("/login")
    },
    handleSubmit (data, callback) {
      console.log("handleSubmit", data)
      certify(data).then(response => {
        console.log("certify", response)
        if (response.error_code === 0) {
          notify(Config.notifySuc, Config.certifySuc)
          this.$router.replace("/result")
          callback(true)
        } else {
          notify(Config.notifyErr, Config.errorMsg[response.error_code])
          callback(false)
          if (response.error_code === Config.tokenTimeout) {
            this.logout()
          }
        }
      }).catch(error => {
        console.log(error)
        notify(Config.notifyErr, Config.serverErrorMsg)
      })
      // if (this.certifyType === "person") {
      //   certifyPerson(data).then(response => {
      //     console.log("certifyPerson", response)
      //     if (response.error_code === 0) {
      //       notify(Config.notifySuc, Config.certifySuc)
      //       this.$router.replace("/result")
      //       callback(true)
      //     } else {
      //       notify(Config.notifyErr, Config.errorMsg[response.error_code])
      //       callback(false)
      //       if (response.error_code === Config.tokenTimeout) {
      //         this.logout()
      //       }
      //     }
      //   }).catch(error => {
      //     console.log(error)
      //     notify(Config.notifyErr, Config.serverErrorMsg)
      //   })
      // } else {
      //   certifyEnterprise(data).then(response => {
      //     console.log("certifyEnterprise", response)
      //     if (response.error_code === 0) {
      //       notify(Config.notifySuc, Config.certifySuc)
      //       this.$router.replace("/result")
      //       callback(true)
      //     } else {
      //       notify(Config.notifyErr, Config.errorMsg[response.error_code])
      //       callback(false)
      //       if (response.error_code === Config.tokenTimeout) {
      //         this.logout()
      //       }
      //     }
      //   }).catch(error => {
      //     console.log(error)
      //     notify(Config.notifyErr, Config.serverErrorMsg)
      //   })
      // }
    },
    checkUserStatus () {
      if (this.accountName) {
        const data = {accountName: this.accountName}
        getCertificationInfo(data).then((response) => {
          console.log("getCertificationInfo", response)
          if (response.error_code === 0 && response.result.status === 1) {
            this.$router.replace("/result")
          } else if (response.error_code === Config.tokenTimeout) {
            this.logout()
          }
        }).catch((error) => {
          console.log(error)
          notify(Config.notifyErr, Config.serverErrorMsg)
        })
      }
    }
  },
  mounted() {
    this.appType = getAppType()
    this.accountName = localStorage.getItem("accountName")
    this.form.accountName = localStorage.getItem("accountName")
    this.checkUserStatus()
  }
}
</script>

<style scoped>
.el-input {
  width: 50%;
}

.account-type {
  margin-top: 5%;
}

.info-title {
  margin-top: 5%;
}

.avatar-uploader .el-upload:hover {
  border-color: #409EFF;
}

.avatar-uploader-icon {
  font-size: 20px;
  color: blue;
  width: 350px;
  height: 180px;
  line-height: 180px;
  text-align: center;
}

.avatar {
  width: 350px;
  height: 180px;
  display: block;
}

.butt {
  margin-top: 20px;
}
</style>
